<template>
<div class="wrapper">
<section class="top_banner" :style="{ 'background-image': 'url(' + imageBanner + ')' }">
  <wv-flex :gutter="0" class="banner_container banner_industry">
    <wv-flex-item>
      <div class="headline">全流程、完善的售后服务体系</div>
      <div class="text">丰富多样的产品，齐全完善的体系，帮助您的KHS设备始终保持最高产能，并提供标准化、个性化的服务产品</div>
    </wv-flex-item>
  </wv-flex>
</section>
<section class="main-content case">
  <div class="project-case-list">
    <template v-for="(value, key) in itemdata.content">
        <div class="project-case-item" :key="key">
          <div class="img_container"><img :src="getImgUrl(value.image)" alt=""></div>
          <div class="text-wrapper">
            <div class="headline">{{ value.headline }}</div>
            <div class="info">{{ value.info }}</div>
          </div>
        </div>
    </template>
  </div>

</section>
</div>
</template>

<script>
import database from '../../static/data/services.json'

export default {
  name: 'ServicePage',
  data () {
    return {
      itemdata: database,
      currentCate: 'all',
      currentCateObj: {'value33': 'all'},
      imageBanner: 'static/images/bg-banner-service.jpg',
      imageIcon01: 'static/images/1-1-icon.png',
      imageIcon02: 'static/images/1-2-icon.png',
      imageIcon03: 'static/images/1-3-icon.png',
      imageIcon04: 'static/images/1-4-icon.png',
      imageIcon05: 'static/images/1-5-icon.png',
      imageIcon06: 'static/images/1-6-icon.png'
    }
  },
  mounted: function () {
    this.$nextTick(function () {
    })
  },
  watch: {
  },
  methods: {
    getRouteUrl: function (url) {
      return url
    },
    getImgUrl: function (img) {
      return 'static/images/' + img
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
  .project-case-list {
    padding: 15px 0;

    .project-case-item {
      position: relative;
      margin: 15px 0;
      box-shadow: 0 0 10px 0 rgba(187,187,187,1);

      img {
        max-height: 563px;
      }

      .text-wrapper {
        padding: 13px 18px 23px;

        .headline {
          font-size: 14px;
          color: #54585a;
        }

        .info {
          font-size: 12px;
          color: #959b9c;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServicePage.vue